<div class="benef-sidebar">

  <!-- Slot : formulaire de recherche -->
  <div class="search-slot">
    <ng-content></ng-content>
  </div>

  <!-- Skeleton loading -->
  <div *ngIf="isLoading" class="benef-card benef-card-placeholder">

    <div class="avatar-section">
      <div class="avatar-wrap avatar-lg">
        <div class="skeleton-circle"></div>
      </div>
      <div class="skeleton-line" style="width:65%; height:0.9rem; margin-top:0.4rem"></div>
      <div class="benef-badges" style="margin-top:0.3rem">
        <span class="skeleton-badge"></span>
        <span class="skeleton-badge"></span>
      </div>
    </div>

    <div class="divider"></div>

    <div class="info-list">
      <div class="info-row" *ngFor="let i of [1,2,3,4,5,6]">
        <span class="skeleton-icon"></span>
        <span class="skeleton-line" style="width:40%"></span>
        <span class="skeleton-line" style="width:45%; margin-left:auto"></span>
      </div>
    </div>

  </div>

  <!-- Carte bénéficiaire -->
  <div *ngIf="!isLoading && itemBeneficiare && itemBeneficiare.id" class="benef-card">

    <!-- Avatar + identité -->
    <div class="avatar-section">
      <div class="avatar-wrap avatar-lg" [class.vip]="itemBeneficiare?.is_vip === 1">
        <img *ngIf="itemBeneficiare?.image_url" [src]="itemBeneficiare.image_url" (error)="onImageError($event)"
          (load)="onImageLoad($event)" class="avatar-img"
          [alt]="'Photo de ' + (itemBeneficiare?.display_name || 'bénéficiaire')">
        <div *ngIf="!itemBeneficiare?.image_url" class="avatar-initials">{{ getInitials() }}</div>
        <div *ngIf="itemBeneficiare?.is_vip === 1" class="vip-crown">
          <i class="fa fa-star"></i>
        </div>
      </div>

      <div class="benef-name">{{ itemBeneficiare.nom }} {{ itemBeneficiare.prenom }}</div>

      <div class="benef-badges">
        <span class="badge-taux">{{ itemBeneficiare?.taux_applicable || 0 }}%</span>
        <span class="badge-statut" [ngClass]="getStatusClass(itemBeneficiare?.statut_codification)">
          {{ itemBeneficiare?.statut_libelle || 'N/A' }} ({{itemBeneficiare.genre_libelle}})
        </span>
      </div>
    </div>

    <!-- Séparateur -->
    <div class="divider"></div>

    <!-- Infos détail -->
    <div class="info-list">

      <div *ngIf="itemBeneficiare.date_naissance" class="info-row">
        <span class="info-icon"><i class="fa fa-calendar"></i></span>
        <div class="info-text">
          <span class="info-key">Naissance</span>
          <span class="info-val">{{ itemBeneficiare.date_naissance | date:'dd/MM/yyyy' }}</span>
        </div>
      </div>

      <div *ngIf="itemBeneficiare.age_detail" class="info-row">
        <span class="info-icon"><i class="fa fa-birthday-cake"></i></span>
        <div class="info-text">
          <span class="info-key">Âge</span>
          <span class="info-val">{{ itemBeneficiare.age_detail }}</span>
        </div>
      </div>

      <div *ngIf="itemBeneficiare.sexe" class="info-row">
        <span class="info-icon"><i class="fa fa-venus-mars"></i></span>
        <div class="info-text">
          <span class="info-key">Sexe</span>
          <span class="info-val">{{ itemBeneficiare.sexe === 'M' ? 'Masculin' : 'Féminin' }}</span>
        </div>
      </div>

      <!-- <div *ngIf="itemBeneficiare.genre_libelle" class="info-row">
        <span class="info-icon"><i class="fa fa-tag"></i></span>
        <div class="info-text">
          <span class="info-key">Genre</span>
          <span class="info-val">{{ itemBeneficiare.genre_libelle }}</span>
        </div>
      </div> -->

      <div *ngIf="itemBeneficiare.numero_cnam" class="info-row">
        <span class="info-icon"><i class="fa fa-credit-card"></i></span>
        <div class="info-text">
          <span class="info-key">N° CMU</span>
          <span class="info-val">{{ itemBeneficiare.numero_cnam }}</span>
        </div>
      </div>

      <div *ngIf="itemBeneficiare.telephone" class="info-row">
        <span class="info-icon"><i class="fa fa-phone"></i></span>
        <div class="info-text">
          <span class="info-key">Tél.</span>
          <span class="info-val">{{ itemBeneficiare.telephone }}</span>
        </div>
      </div>

      <div *ngIf="itemBeneficiare.police_libelle" class="info-row">
        <span class="info-icon"><i class="fa fa-file-contract"></i></span>
        <div class="info-text">
          <span class="info-key">Police</span>
          <span class="info-val" [title]="itemBeneficiare.police_libelle">{{ itemBeneficiare.police_libelle }}</span>
        </div>
      </div>

      <div *ngIf="itemBeneficiare.college_libelle" class="info-row">
        <span class="info-icon"><i class="fa fa-users"></i></span>
        <div class="info-text">
          <span class="info-key">Collège</span>
          <span class="info-val" [title]="itemBeneficiare.college_libelle">{{ itemBeneficiare.college_libelle }}</span>
        </div>
      </div>

    </div>
  </div>

  <!-- Masque vide — avant toute recherche -->
  <div *ngIf="!isLoading && !searchAttempted" class="benef-card benef-card-placeholder">

    <div class="avatar-section">
      <div class="avatar-wrap avatar-lg">
        <div class="avatar-initials placeholder-initials"><i class="fa fa-user"></i></div>
      </div>
      <div class="benef-name placeholder-line placeholder-name"></div>
      <div class="benef-badges">
        <span class="placeholder-badge"></span>
        <span class="placeholder-badge"></span>
      </div>
    </div>

    <div class="divider"></div>

    <div class="info-list">
      <div class="info-row" *ngFor="let i of [1,2,3,4,5]">
        <span class="info-icon placeholder-icon"></span>
        <span class="info-key placeholder-line" style="width:40%"></span>
        <span class="info-val placeholder-line" style="width:50%"></span>
      </div>
    </div>

  </div>

  <!-- État vide (après tentative de recherche infructueuse) -->
  <div *ngIf="!isLoading && searchAttempted && (!itemBeneficiare || !itemBeneficiare.id)" class="state-empty">
    <i class="fa fa-user-slash"></i>
    <p>Aucun bénéficiaire trouvé</p>
    <small>Vérifiez le numéro et réessayez</small>
  </div>

</div>